// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.socket-control-panel {
  font-family: "Segoe UI", sans-serif;
  padding: 24px;
  background-color: #f9f9f9;
  color: #333;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: auto;
  padding-top: 100px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 14px;
}

.connected {
  background-color: #d1f5d3;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.disconnected {
  background-color: #fdecea;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.connection-controls {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.control-btn {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.connect-btn {
  background-color: #4caf50;
  color: white;
}

.connect-btn:hover {
  background-color: #43a047;
}

.disconnect-btn {
  background-color: #f44336;
  color: white;
}

.disconnect-btn:hover {
  background-color: #e53935;
}

.event-section {
  margin-top: 30px;
}

.event-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.event-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 16px;
  transition: box-shadow 0.2s, transform 0.2s;
}

.event-card.active {
  border-color: #90caf9;
  box-shadow: 0 0 0 2px #bbdefb;
}

.event-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
}

.event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.event-name {
  font-weight: 600;
  font-size: 15px;
}

.toggle-btn {
  padding: 4px 10px;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background-color: #e0e0e0;
  color: #333;
}

.toggle-btn.active {
  background-color: #64b5f6;
  color: white;
}

.broadcast-btn {
  margin-top: 10px;
  width: 100%;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.broadcast-btn:hover {
  background-color: #1565c0;
}

.log-section {
  margin-top: 40px;
}

.log-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  max-height: 300px;
  overflow-y: auto;
}

.log-entry {
  margin-bottom: 14px;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 10px;
}

.log-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #555;
  margin-bottom: 4px;
}

.log-data {
  font-family: monospace;
  font-size: 13px;
  background-color: #f5f5f5;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: pre-wrap;
}

.empty-log {
  text-align: center;
  font-style: italic;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/components/SocketControlPanel/SocketControlPanel.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".socket-control-panel {\n  font-family: \"Segoe UI\", sans-serif;\n  padding: 24px;\n  background-color: #f9f9f9;\n  color: #333;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  margin: auto;\n  padding-top: 100px;\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 14px;\n}\n\n.connected {\n  background-color: #d1f5d3;\n  color: #2e7d32;\n  border: 1px solid #a5d6a7;\n}\n\n.disconnected {\n  background-color: #fdecea;\n  color: #c62828;\n  border: 1px solid #ef9a9a;\n}\n\n.connection-controls {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.control-btn {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.connect-btn {\n  background-color: #4caf50;\n  color: white;\n}\n\n.connect-btn:hover {\n  background-color: #43a047;\n}\n\n.disconnect-btn {\n  background-color: #f44336;\n  color: white;\n}\n\n.disconnect-btn:hover {\n  background-color: #e53935;\n}\n\n.event-section {\n  margin-top: 30px;\n}\n\n.event-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.event-card {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 16px;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.event-card.active {\n  border-color: #90caf9;\n  box-shadow: 0 0 0 2px #bbdefb;\n}\n\n.event-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);\n}\n\n.event-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.event-name {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.toggle-btn {\n  padding: 4px 10px;\n  border-radius: 4px;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.toggle-btn.active {\n  background-color: #64b5f6;\n  color: white;\n}\n\n.broadcast-btn {\n  margin-top: 10px;\n  width: 100%;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.broadcast-btn:hover {\n  background-color: #1565c0;\n}\n\n.log-section {\n  margin-top: 40px;\n}\n\n.log-container {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.log-entry {\n  margin-bottom: 14px;\n  border-bottom: 1px dashed #ccc;\n  padding-bottom: 10px;\n}\n\n.log-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #555;\n  margin-bottom: 4px;\n}\n\n.log-data {\n  font-family: monospace;\n  font-size: 13px;\n  background-color: #f5f5f5;\n  padding: 6px 10px;\n  border-radius: 4px;\n  white-space: pre-wrap;\n}\n\n.empty-log {\n  text-align: center;\n  font-style: italic;\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
